(function () {
    "use strict";

    
    angular.module('app').filter('chopString', ChopStringFactory);
    function ChopStringFactory() {
        return function (value, desiredLength = 100) {
            if (!value || value.length <=  desiredLength)
                return value;
            return `${value.substring(0, desiredLength)} ...`;
        };
    }
})();